
import Maps from '../maps.json'

const MapSelectorButton = ({disabled, onclick, index, name}) => {
    return (
        <button onClick={() => onclick(index)} disabled={disabled} type="button" className="
        font-zion h-8 w-8 sm:h-10 sm:w-10 
        pt-1 disabled:bg-[#c7b424] bg-[#fcf010]
        text-md sm:text-xl rounded-sm shadow-md
        hover:bg-[#fcdc0c] hover:shadow-lg focus:bg-[#fcf010] focus:shadow-lg 
        focus:outline-none focus:ring-0 active:bg-[#fcf010] active:shadow-lg
        transition duration-150 ease-in-out">{name}</button>
    );
}


const MapSelector = ({handleClick, selectedIndex}) => {
    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-4">
            {Maps.maps.map((map,index) => <MapSelectorButton key={index} disabled={selectedIndex===index} onclick={handleClick} index={index} name={map.name}/>)}
        </div>
    );
}

export default MapSelector